import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { CwtSpinnerComponent } from "./cwt-spinner.component";

@NgModule({
    imports: [CommonModule, CwtSpinnerComponent],
    exports: [CwtSpinnerComponent],
})
export class CwtSpinnerModule {}
